import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


const CommercialRent = () => {
    const steps = ['Basic Details', 'Property Details', 'Price Details', 'Photos', 'Review & Submit'];
    const [activeStep, setActiveStep] = useState(0);
    const [error, setError] = useState("");

    const token = localStorage.getItem('authToken');


    // State to store form data for all steps
    const [formData, setFormData] = useState({
        basicDetails: { type: 'commercial', service: 'rent', address: '', property_type: '' },

        propertyDetails: {
            building: '', locality: '', property_name: '', possession_status: '', available_from: '', property_age: '', zone_type: '', location_hub: '', other_location_hub: '',
            property_condition: '', builtup_area: '', carpet_area: '', plot_area: '', ownership: '', construction_status: '', total_floor: '', your_floor: '', number_seat: '', number_cabin: ''
        },
        priceDetails: {
            monthlyRent: ''
        },
        photos: { files: null },
    });

    const [errors, setErrors] = useState({});

    const handleInputChange = (step, field, value) => {

        setFormData((prev) => ({
            ...prev,
            [step]: {
                ...prev[step],
                [field]: value,
            },
        }));
        setErrors((prev) => ({
            ...prev,
            [field]: '', // Clear error for the field being modified
        }));
    };

    const validateStep = () => {
        const newErrors = {};
        if (activeStep === 0) {
            if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
            if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
            if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
            if (!formData.basicDetails.property_type) newErrors.property_type = "Property Type is required.";
        }
        if (activeStep === 1) {

            // ValidationError for Office
            if (['office'].includes(formData.basicDetails.property_type)) {

                if (!formData.propertyDetails.building.trim()) {
                    newErrors.building = "Building/Project/Society is required.";
                }
                if (!formData.propertyDetails.locality.trim()) {
                    newErrors.locality = "Locality is required.";
                }
                if (!formData.propertyDetails.possession_status) {
                    newErrors.possession_status = "Possession Status is required.";
                }
                if (!formData.propertyDetails.available_from) {
                    newErrors.available_from = "Available From is required.";
                }
                if (['ready_move'].includes(formData.propertyDetails.possession_status)) {
                    if (!formData.propertyDetails.property_age) {
                        newErrors.property_age = "Property Age is required.";
                    }
                }

                if (!formData.propertyDetails.zone_type) {
                    newErrors.zone_type = "Zone Type is required.";
                }

                if (!formData.propertyDetails.location_hub) {
                    newErrors.location_hub = "Location Hub is required.";
                }

                if (['others'].includes(formData.propertyDetails.location_hub)) {
                    if (!formData.propertyDetails.other_location_hub.trim()) {
                        newErrors.other_location_hub = "Other Location Hub is required.";
                    }
                }

                if (!formData.propertyDetails.property_condition) {
                    newErrors.property_condition = "Property Condition is required.";
                }

                if (!formData.propertyDetails.builtup_area.trim()) {
                    newErrors.builtup_area = "Build Up is required.";
                }

                if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
                    if (!formData.propertyDetails.carpet_area.trim()) {
                        newErrors.carpet_area = "Carpet Area is required.";
                    }
                    if (!formData.propertyDetails.number_seat.trim()) {
                        newErrors.number_seat = "Number Seat is required.";
                    }
                    if (!formData.propertyDetails.number_cabin.trim()) {
                        newErrors.number_cabin = "Number Cabin is required.";
                    }
                }
                if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
                    if (!formData.propertyDetails.construction_status) {
                        newErrors.construction_status = "Construction Status is required.";
                    }
                }
                if (!formData.propertyDetails.ownership) {
                    newErrors.ownership = "Ownership is required.";
                }
                if (!formData.propertyDetails.total_floor.trim()) {
                    newErrors.total_floor = "Total Floor is required.";
                }
                if (!formData.propertyDetails.your_floor) {
                    newErrors.your_floor = "Your Floor is required.";
                }
            }


            // ValidationError for Retail and Showroom
            if (['retail_shop', 'showroom'].includes(formData.basicDetails.property_type)) {

                if (!formData.propertyDetails.building.trim()) {
                    newErrors.building = "Building/Project/Society is required.";
                }
                if (!formData.propertyDetails.locality.trim()) {
                    newErrors.locality = "Locality is required.";
                }
                if (!formData.propertyDetails.possession_status) {
                    newErrors.possession_status = "Possession Status is required.";
                }
                if (!formData.propertyDetails.available_from) {
                    newErrors.available_from = "Available From is required.";
                }
                if (['ready_move'].includes(formData.propertyDetails.possession_status)) {
                    if (!formData.propertyDetails.property_age) {
                        newErrors.property_age = "Property Age is required.";
                    }
                }
                if (!formData.propertyDetails.location_hub) {
                    newErrors.location_hub = "Location Hub is required.";
                }

                if (['others'].includes(formData.propertyDetails.location_hub)) {
                    if (!formData.propertyDetails.other_location_hub.trim()) {
                        newErrors.other_location_hub = "Other Location Hub is required.";
                    }
                }

                if (!formData.propertyDetails.builtup_area.trim()) {
                    newErrors.builtup_area = "Build Up is required.";
                }
                if (!formData.propertyDetails.carpet_area.trim()) {
                    newErrors.carpet_area = "Carpet Area is required.";
                }

                if (!formData.propertyDetails.ownership) {
                    newErrors.ownership = "Ownership is required.";
                }
                if (!formData.propertyDetails.total_floor.trim()) {
                    newErrors.total_floor = "Total Floor is required.";
                }
                if (!formData.propertyDetails.your_floor) {
                    newErrors.your_floor = "Your Floor is required.";
                }
            }

            //Validation for WareHouse
            if (['warehouse'].includes(formData.basicDetails.property_type)) {

                if (!formData.propertyDetails.building.trim()) {
                    newErrors.building = "Building/Project/Society is required.";
                }
                if (!formData.propertyDetails.locality.trim()) {
                    newErrors.locality = "Locality is required.";
                }
                if (!formData.propertyDetails.possession_status) {
                    newErrors.possession_status = "Possession Status is required.";
                }
                if (!formData.propertyDetails.available_from) {
                    newErrors.available_from = "Available From is required.";
                }
                if (['ready_move'].includes(formData.propertyDetails.possession_status)) {
                    if (!formData.propertyDetails.property_age) {
                        newErrors.property_age = "Property Age is required.";
                    }
                }

                if (!formData.propertyDetails.zone_type) {
                    newErrors.zone_type = "Zone Type is required.";
                }

                if (!formData.propertyDetails.location_hub) {
                    newErrors.location_hub = "Location Hub is required.";
                }

                if (['others'].includes(formData.propertyDetails.location_hub)) {
                    if (!formData.propertyDetails.other_location_hub.trim()) {
                        newErrors.other_location_hub = "Other Location Hub is required.";
                    }
                }

                if (!formData.propertyDetails.property_condition) {
                    newErrors.property_condition = "Property Condition is required.";
                }

                if (!formData.propertyDetails.builtup_area.trim()) {
                    newErrors.builtup_area = "Build Up is required.";
                }

                if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
                    if (!formData.propertyDetails.carpet_area.trim()) {
                        newErrors.carpet_area = "Carpet Area is required.";
                    }
                    if (!formData.propertyDetails.number_seat.trim()) {
                        newErrors.number_seat = "Number Seat is required.";
                    }
                    if (!formData.propertyDetails.number_cabin.trim()) {
                        newErrors.number_cabin = "Number Cabin is required.";
                    }
                }
                if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
                    if (!formData.propertyDetails.construction_status) {
                        newErrors.construction_status = "Construction Status is required.";
                    }
                }
                if (!formData.propertyDetails.ownership) {
                    newErrors.ownership = "Ownership is required.";
                }
                if (!formData.propertyDetails.total_floor.trim()) {
                    newErrors.total_floor = "Total Floor is required.";
                }
                if (!formData.propertyDetails.your_floor) {
                    newErrors.your_floor = "Your Floor is required.";
                }
            }

            //Validation for Plot
            if (['plot'].includes(formData.basicDetails.property_type)) {

                if (!formData.propertyDetails.building.trim()) {
                    newErrors.building = "Building/Project/Society is required.";
                }
                if (!formData.propertyDetails.locality.trim()) {
                    newErrors.locality = "Locality is required.";
                }
                if (!formData.propertyDetails.available_from) {
                    newErrors.available_from = "Available From is required.";
                }

                if (!formData.propertyDetails.zone_type) {
                    newErrors.zone_type = "Zone Type is required.";
                }
                if (!formData.propertyDetails.plot_area.trim()) {
                    newErrors.plot_area = "Plot Area is required.";
                }
                if (!formData.propertyDetails.ownership) {
                    newErrors.ownership = "Ownership is required.";
                }
            }

            // ValidationError for Others
            if (['others'].includes(formData.basicDetails.property_type)) {

                if (!formData.propertyDetails.building.trim()) {
                    newErrors.building = "Building/Project/Society is required.";
                }
                if (!formData.propertyDetails.locality.trim()) {
                    newErrors.locality = "Locality is required.";
                }
                if (!formData.propertyDetails.property_name.trim()) {
                    newErrors.property_name = "Property Name required.";
                }
                if (!formData.propertyDetails.possession_status) {
                    newErrors.possession_status = "Possession Status is required.";
                }
                if (!formData.propertyDetails.available_from) {
                    newErrors.available_from = "Available From is required.";
                }
                if (['ready_move'].includes(formData.propertyDetails.possession_status)) {
                    if (!formData.propertyDetails.property_age) {
                        newErrors.property_age = "Property Age is required.";
                    }
                }
                if (!formData.propertyDetails.zone_type) {
                    newErrors.zone_type = "Zone Type is required.";
                }
                if (!formData.propertyDetails.location_hub) {
                    newErrors.location_hub = "Location Hub is required.";
                }
                if (['others'].includes(formData.propertyDetails.location_hub)) {
                    if (!formData.propertyDetails.other_location_hub.trim()) {
                        newErrors.other_location_hub = "Other Location Hub is required.";
                    }
                }
                if (!formData.propertyDetails.builtup_area.trim()) {
                    newErrors.builtup_area = "Build Up is required.";
                }
                if (!formData.propertyDetails.carpet_area.trim()) {
                    newErrors.carpet_area = "Carpet Area is required.";
                }
                if (!formData.propertyDetails.ownership) {
                    newErrors.ownership = "Ownership is required.";
                }
                if (!formData.propertyDetails.total_floor.trim()) {
                    newErrors.total_floor = "Total Floor is required.";
                }
                if (!formData.propertyDetails.your_floor) {
                    newErrors.your_floor = "Your Floor is required.";
                }
            }


        }
        if (activeStep === 2) {
            if (!formData.priceDetails.monthlyRent) newErrors.monthlyRent = "Expected Rent is required";
        }
        if (activeStep === 3) {
            if (!formData.photos[0]) newErrors.files = "Please upload at least one image.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChangeFiles = (e) => {
        const { name, files } = e.target;

        if (name === 'image' && files.length > 0) {
            // Convert the FileList to an array
            const fileArray = Array.from(files);

            console.log(fileArray);

            setFormData((prev) => ({
                ...prev,
                photos: fileArray, // Replace the previous photos array with the new files
            }));
        }
        setErrors((prev) => ({
            ...prev,
            photos: '', // Clear error for photos
        }));

    };

    const handleNextStep = () => {
        if (validateStep()) {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleSubmit = async (e) => {
        //alert(JSON.stringify(formData));  
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/residentialRent`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`, // Attach Bearer token
                    'Content-Type': 'multipart/form-data', // Set correct content type for file upload
                },
            });
            console.log('API Response:', response.data);
            alert("Property Add SuccessFully");
        } catch (error) {
            console.error("Property Add error:", error);
            setError("An error occurred. Please try again later.");
        }
    };

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Property Type</label>
                            <div className="btn-group" role="group">
                                <Link to="/residentialRent">
                                    <button
                                        type="button"
                                        className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                                    >
                                        Residential
                                    </button>
                                </Link>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                                >
                                    Commercial
                                </button>
                            </div>
                            {errors.type && <small className="text-danger">{errors.type}</small>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Looking to</label>
                            <div className="btn-group" role="group">

                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                                >
                                    Rent
                                </button>

                                <Link to="/commercialSell">
                                    <button
                                        type="button"
                                        className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                                    >
                                        Sell
                                    </button>
                                </Link>
                            </div>
                            {errors.service && <small className="text-danger">{errors.service}</small>}
                        </div>


                        <div className="mb-3">
                            <label className="form-label">Address</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.basicDetails.address}
                                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
                            />
                            {errors.address && <small className="text-danger">{errors.address}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Property Type</label>
                            <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'office' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'office')}
                                >
                                    Office
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'retail_shop' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'retail_shop')}
                                >
                                    Retail Shop
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'showroom' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'showroom')}
                                >
                                    Showroom
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'warehouse' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'warehouse')}
                                >
                                    Warehouse
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'plot' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'plot')}
                                >
                                    Plot
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${formData.basicDetails.property_type === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => handleInputChange('basicDetails', 'property_type', 'others')}
                                >
                                    Others
                                </button>
                            </div>
                            {errors.property_type && <small className="text-danger">{errors.property_type}</small>}
                        </div>
                    </div>
                );
            case 1:
                return (
                    <>
                        {formData.basicDetails.property_type === 'office' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Possession Status</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'ready_move' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'ready_move')}
                                        >
                                            Ready to Move
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'under_construction' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'under_construction')}
                                        >
                                            Under Construction
                                        </button>
                                    </div>
                                    {errors.possession_status && <small className="text-danger">{errors.possession_status}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                {formData.propertyDetails.possession_status === 'ready_move' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Age of Property(in years)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
                                            />
                                            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
                                        </div>

                                    </>
                                )}


                                <div className="mb-3">
                                    <label className="form-label">Zone Type</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'industrial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'industrial')}
                                        >
                                            Industrial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'commercial')}
                                        >
                                            Commercial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'residential')}
                                        >
                                            Residential
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'special_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'special_zone', 'under_construction')}
                                        >
                                            Special Economic Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'open_space' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'open_space', 'under_construction')}
                                        >
                                            Open Spaces
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'agricultural_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'agricultural_zone', 'under_construction')}
                                        >
                                            Agricultural Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'others', 'under_construction')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.zone_type && <small className="text-danger">{errors.zone_type}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Location Hub</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'it_park' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'it_park')}
                                        >
                                            IT Park
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'business_park' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'business_park')}
                                        >
                                            Business Park
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'others')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.location_hub && <small className="text-danger">{errors.location_hub}</small>}
                                </div>

                                {formData.propertyDetails.location_hub === 'others' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Others(Location Hub)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'other_location_hub', e.target.value)}
                                            />
                                            {errors.other_location_hub && <small className="text-danger">{errors.other_location_hub}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Property Condition</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.property_condition === 'ready_use' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'property_condition', 'ready_use')}
                                        >
                                            Ready to Use
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.property_condition === 'bare_shell' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'property_condition', 'bare_shell')}
                                        >
                                            Bare shell
                                        </button>
                                    </div>
                                    {errors.property_condition && <small className="text-danger">{errors.property_condition}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Build Up Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.builtup_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'builtup_area', e.target.value)}
                                    />
                                    {errors.builtup_area && <small className="text-danger">{errors.builtup_area}</small>}
                                </div>

                                {formData.propertyDetails.property_condition === 'ready_use' && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Carpet Area</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.carpet_area}
                                                onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                                            />
                                            {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>

                                {formData.propertyDetails.property_condition === 'bare_shell' && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Construction Status</label>
                                            <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                <button
                                                    type="button"
                                                    className={`btn ${formData.propertyDetails.construction_status === 'no_walls' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => handleInputChange('propertyDetails', 'construction_status', 'no_walls')}
                                                >
                                                    No Walls
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn ${formData.propertyDetails.construction_status === 'bricks_wall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => handleInputChange('propertyDetails', 'construction_status', 'bricks_wall')}
                                                >
                                                    Brick Walls
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn ${formData.propertyDetails.construction_status === 'cemented_wall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => handleInputChange('propertyDetails', 'construction_status', 'cemented_wall')}
                                                >
                                                    Cemented Walls
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn ${formData.propertyDetails.construction_status === 'plaster_wall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => handleInputChange('propertyDetails', 'construction_status', 'plaster_wall')}
                                                >
                                                    Plastered Walls
                                                </button>
                                            </div>
                                            {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                        </div>
                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Total Floor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.total_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
                                    />
                                    {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Your Floor</label>
                                    <select className="form-control" value={formData.propertyDetails.your_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'your_floor', e.target.value)}>
                                        <option>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                    </select>
                                    {errors.your_floor && <small className="text-danger">{errors.your_floor}</small>}
                                </div>

                                {formData.propertyDetails.property_condition === 'ready_use' && (
                                    <>
                                        <div className='md-3'>
                                            <label className="form-label">FACILITIES</label>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Number of Seat</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.number_seat}
                                                onChange={(e) => handleInputChange('propertyDetails', 'number_seat', e.target.value)}
                                            />
                                            {errors.number_seat && <small className="text-danger">{errors.number_seat}</small>}
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Number of Cabins</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.number_cabin}
                                                onChange={(e) => handleInputChange('propertyDetails', 'number_cabin', e.target.value)}
                                            />
                                            {errors.number_cabin && <small className="text-danger">{errors.number_cabin}</small>}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {formData.basicDetails.property_type === 'retail_shop' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Possession Status</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'ready_move' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'ready_move')}
                                        >
                                            Ready to Move
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'under_construction' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'under_construction')}
                                        >
                                            Under Construction
                                        </button>
                                    </div>
                                    {errors.possession_status && <small className="text-danger">{errors.possession_status}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                {formData.propertyDetails.possession_status === 'ready_move' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Age of Property(in years)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
                                            />
                                            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Location Hub</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'mall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'mall')}
                                        >
                                            Mall
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'commercial_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'commercial_project')}
                                        >
                                            Commercial Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'residential_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'residential_project')}
                                        >
                                            Residential Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'complex_building' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'complex_building')}
                                        >
                                            Retail Complex/Building
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'market_street' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'market_street')}
                                        >
                                            Market/High Street
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'others')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.location_hub && <small className="text-danger">{errors.location_hub}</small>}
                                </div>

                                {formData.propertyDetails.location_hub === 'others' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Others(Location Hub)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'other_location_hub', e.target.value)}
                                            />
                                            {errors.other_location_hub && <small className="text-danger">{errors.other_location_hub}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Build Up Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.builtup_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'builtup_area', e.target.value)}
                                    />
                                    {errors.builtup_area && <small className="text-danger">{errors.builtup_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Carpet Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.carpet_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                                    />
                                    {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Total Floor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.total_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
                                    />
                                    {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Your Floor</label>
                                    <select className="form-control" value={formData.propertyDetails.your_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'your_floor', e.target.value)}>
                                        <option>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                    </select>
                                    {errors.your_floor && <small className="text-danger">{errors.your_floor}</small>}
                                </div>

                            </div>
                        )}

                        {formData.basicDetails.property_type === 'showroom' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Possession Status</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'ready_move' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'ready_move')}
                                        >
                                            Ready to Move
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'under_construction' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'under_construction')}
                                        >
                                            Under Construction
                                        </button>
                                    </div>
                                    {errors.possession_status && <small className="text-danger">{errors.possession_status}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                {formData.propertyDetails.possession_status === 'ready_move' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Age of Property(in years)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
                                            />
                                            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Location Hub</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'mall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'mall')}
                                        >
                                            Mall
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'commercial_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'commercial_project')}
                                        >
                                            Commercial Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'residential_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'residential_project')}
                                        >
                                            Residential Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'complex_building' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'complex_building')}
                                        >
                                            Retail Complex/Building
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'market_street' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'market_street')}
                                        >
                                            Market/High Street
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'others')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.location_hub && <small className="text-danger">{errors.location_hub}</small>}
                                </div>

                                {formData.propertyDetails.location_hub === 'others' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Others(Location Hub)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'other_location_hub', e.target.value)}
                                            />
                                            {errors.other_location_hub && <small className="text-danger">{errors.other_location_hub}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Build Up Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.builtup_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'builtup_area', e.target.value)}
                                    />
                                    {errors.builtup_area && <small className="text-danger">{errors.builtup_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Carpet Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.carpet_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                                    />
                                    {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Total Floor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.total_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
                                    />
                                    {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Your Floor</label>
                                    <select className="form-control" value={formData.propertyDetails.your_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'your_floor', e.target.value)}>
                                        <option>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                    </select>
                                    {errors.your_floor && <small className="text-danger">{errors.your_floor}</small>}
                                </div>

                            </div>
                        )}

                        {formData.basicDetails.property_type === 'warehouse' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Possession Status</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'ready_move' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'ready_move')}
                                        >
                                            Ready to Move
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'under_construction' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'under_construction')}
                                        >
                                            Under Construction
                                        </button>
                                    </div>
                                    {errors.possession_status && <small className="text-danger">{errors.possession_status}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                {formData.propertyDetails.possession_status === 'ready_move' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Age of Property(in years)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
                                            />
                                            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Zone Type</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'industrial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'industrial')}
                                        >
                                            Industrial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'commercial')}
                                        >
                                            Commercial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'residential')}
                                        >
                                            Residential
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'special_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'special_zone', 'under_construction')}
                                        >
                                            Special Economic Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'open_space' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'open_space', 'under_construction')}
                                        >
                                            Open Spaces
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'agricultural_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'agricultural_zone', 'under_construction')}
                                        >
                                            Agricultural Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'others', 'under_construction')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.zone_type && <small className="text-danger">{errors.zone_type}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Location Hub</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'mall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'mall')}
                                        >
                                            Mall
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'commercial_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'commercial_project')}
                                        >
                                            Commercial Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'residential_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'residential_project')}
                                        >
                                            Residential Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'complex_building' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'complex_building')}
                                        >
                                            Retail Complex/Building
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'market_street' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'market_street')}
                                        >
                                            Market/High Street
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'others')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.location_hub && <small className="text-danger">{errors.location_hub}</small>}
                                </div>

                                {formData.propertyDetails.location_hub === 'others' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Others(Location Hub)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'other_location_hub', e.target.value)}
                                            />
                                            {errors.other_location_hub && <small className="text-danger">{errors.other_location_hub}</small>}
                                        </div>

                                    </>
                                )}



                                <div className="mb-3">
                                    <label className="form-label">Build Up Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.builtup_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'builtup_area', e.target.value)}
                                    />
                                    {errors.builtup_area && <small className="text-danger">{errors.builtup_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Carpet Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.carpet_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                                    />
                                    {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Total Floor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.total_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
                                    />
                                    {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Your Floor</label>
                                    <select className="form-control" value={formData.propertyDetails.your_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'your_floor', e.target.value)}>
                                        <option>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                    </select>
                                    {errors.your_floor && <small className="text-danger">{errors.your_floor}</small>}
                                </div>

                            </div>
                        )}

                        {formData.basicDetails.property_type === 'plot' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Zone Type</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'industrial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'industrial')}
                                        >
                                            Industrial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'commercial')}
                                        >
                                            Commercial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'residential')}
                                        >
                                            Residential
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'special_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'special_zone', 'under_construction')}
                                        >
                                            Special Economic Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'open_space' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'open_space', 'under_construction')}
                                        >
                                            Open Spaces
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'agricultural_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'agricultural_zone', 'under_construction')}
                                        >
                                            Agricultural Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'others', 'under_construction')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.zone_type && <small className="text-danger">{errors.zone_type}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Plot Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.plot_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'plot_area', e.target.value)}
                                    />
                                    {errors.plot_area && <small className="text-danger">{errors.plot_area}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>

                            </div>
                        )}

                        {formData.basicDetails.property_type === 'others' && (
                            <div>

                                <div className="mb-3">
                                    <label className="form-label">Building/Project/Society</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.building}
                                        onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                                    />
                                    {errors.building && <small className="text-danger">{errors.building}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Locality</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.locality}
                                        onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
                                    />
                                    {errors.locality && <small className="text-danger">{errors.locality}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Property Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.property_name}
                                        onChange={(e) => handleInputChange('propertyDetails', 'property_name', e.target.value)}
                                    />
                                    {errors.property_name && <small className="text-danger">{errors.property_name}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Possession Status</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'ready_move' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'ready_move')}
                                        >
                                            Ready to Move
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.possession_status === 'under_construction' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'possession_status', 'under_construction')}
                                        >
                                            Under Construction
                                        </button>
                                    </div>
                                    {errors.possession_status && <small className="text-danger">{errors.possession_status}</small>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Available From</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.propertyDetails.available_from}
                                        onChange={(e) => handleInputChange('propertyDetails', 'available_from', e.target.value)}
                                    />
                                    {errors.available_from && <small className="text-danger">{errors.available_from}</small>}
                                </div>

                                {formData.propertyDetails.possession_status === 'ready_move' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Age of Property(in years)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'property_age', e.target.value)}
                                            />
                                            {errors.property_age && <small className="text-danger">{errors.property_age}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Zone Type</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'industrial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'industrial')}
                                        >
                                            Industrial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'commercial')}
                                        >
                                            Commercial
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'zone_type', 'residential')}
                                        >
                                            Residential
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'special_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'special_zone', 'under_construction')}
                                        >
                                            Special Economic Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'open_space' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'open_space', 'under_construction')}
                                        >
                                            Open Spaces
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'agricultural_zone' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'agricultural_zone', 'under_construction')}
                                        >
                                            Agricultural Zone
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.zone_type === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'others', 'under_construction')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.zone_type && <small className="text-danger">{errors.zone_type}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Location Hub</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'mall' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'mall')}
                                        >
                                            Mall
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'commercial_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'commercial_project')}
                                        >
                                            Commercial Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'residential_project' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'residential_project')}
                                        >
                                            Residential Project
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'complex_building' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'complex_building')}
                                        >
                                            Retail Complex/Building
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'market_street' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'market_street')}
                                        >
                                            Market/High Street
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.location_hub === 'others' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'location_hub', 'others')}
                                        >
                                            Others
                                        </button>
                                    </div>
                                    {errors.location_hub && <small className="text-danger">{errors.location_hub}</small>}
                                </div>

                                {formData.propertyDetails.location_hub === 'others' && (
                                    <>


                                        <div className="mb-3">
                                            <label className="form-label">Others(Location Hub)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.propertyDetails.property_age}
                                                onChange={(e) => handleInputChange('propertyDetails', 'other_location_hub', e.target.value)}
                                            />
                                            {errors.other_location_hub && <small className="text-danger">{errors.other_location_hub}</small>}
                                        </div>

                                    </>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Build Up Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.builtup_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'builtup_area', e.target.value)}
                                    />
                                    {errors.builtup_area && <small className="text-danger">{errors.builtup_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Carpet Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.carpet_area}
                                        onChange={(e) => handleInputChange('propertyDetails', 'carpet_area', e.target.value)}
                                    />
                                    {errors.carpet_area && <small className="text-danger">{errors.carpet_area}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Ownership</label>
                                    <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'freehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'freehold')}
                                        >
                                            Freehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'leasehold' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'leasehold')}
                                        >
                                            Leasehold
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'cooperative_society' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'cooperative_society')}
                                        >
                                            Cooperative Society
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${formData.propertyDetails.ownership === 'power_attorney' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleInputChange('propertyDetails', 'ownership', 'power_attorney')}
                                        >
                                            Power of attorney
                                        </button>
                                    </div>
                                    {errors.ownership && <small className="text-danger">{errors.ownership}</small>}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Total Floor</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.propertyDetails.total_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'total_floor', e.target.value)}
                                    />
                                    {errors.total_floor && <small className="text-danger">{errors.total_floor}</small>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Your Floor</label>
                                    <select className="form-control" value={formData.propertyDetails.your_floor}
                                        onChange={(e) => handleInputChange('propertyDetails', 'your_floor', e.target.value)}>
                                        <option>Select</option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                    </select>
                                    {errors.your_floor && <small className="text-danger">{errors.your_floor}</small>}
                                </div>

                            </div>
                        )}
                    </>
                );
            case 2:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Financials</label>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Expected Rent</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.priceDetails.monthlyRent}
                                onChange={(e) => handleInputChange('priceDetails', 'monthlyRent', e.target.value)}
                            />
                            {errors.monthlyRent && <small className="text-danger">{errors.monthlyRent}</small>}
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <div className="mb-3">
                            <label className="form-label">Upload Photos</label>
                            <input
                                type="file"
                                name='image'
                                onChange={(e) => handleChangeFiles(e)}
                                className="form-control"
                                multiple
                            />
                            {errors.files && <small className="text-danger">{errors.files}</small>}
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Review</label>
                                <div>
                                    <p>Review all the entered details:</p>
                                    <pre>{JSON.stringify(formData, null, 2)}</pre>
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                );
            default:
                return <p>Select a step to continue.</p>;
        }
    };

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-4">
                    <div className="list-group">
                        {steps.map((step, index) => (
                            <button
                                key={index}
                                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                                onClick={() => setActiveStep(index)}
                            >
                                {step}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="col-md-8">
                    <div className="card">
                        <div className="card-header">{steps[activeStep]}</div>
                        <div className="card-body">{renderStepContent(activeStep)}</div>
                        <div className="card-footer text-end">
                            {activeStep > 0 && (
                                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                                    Previous
                                </button>
                            )}
                            {activeStep < steps.length - 1 ? (
                                <button className="btn btn-primary" onClick={handleNextStep}>
                                    Next
                                </button>
                            ) : (
                                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                                    Submit
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommercialRent
